export default __webpack_public_path__ + "static/before-75556e9e7e2ae1d425b0929822dfa08d.jpg";